/**
 * 登出时彻底清除浏览器本地存储（批次 1 / E1，Design §9.2 离职/共享机器场景）。
 *
 * 背景：handleLogout 原先只调 clearSession()（仅把 zustand 持久化的 admin-session
 * 键写回 null）。在共享/公用电脑上，残留的 localStorage / sessionStorage / IndexedDB
 * 仍可能留下账号痕迹。本工具在登出时一次性清空三类本地存储。
 *
 * 注意：这是「本机」清理。停用他人账号的「远程清缓存」无法自动完成（你清不了
 * 别人浏览器），真正的服务端防线是 token 黑名单 + 会话撤销（已实现），admins 页
 * 的对应提示文案因此保持「通知运维/HR SOP」语义。
 *
 * 全部 best-effort：任一存储不可用（隐私模式 / 旧浏览器无 indexedDB.databases）
 * 都不应阻断登出流程，故逐项 try/catch 吞错。
 */
export function clearBrowserStorage(): void {
  try {
    window.localStorage?.clear();
  } catch {
    /* 隐私模式下 localStorage 可能抛错，忽略 */
  }
  try {
    window.sessionStorage?.clear();
  } catch {
    /* 同上 */
  }
  try {
    const idb = window.indexedDB;
    // indexedDB.databases() 是较新 API；不存在则跳过（无法枚举即无法逐个删除）。
    if (idb && typeof idb.databases === 'function') {
      void idb
        .databases()
        .then((dbs) => {
          for (const db of dbs) {
            if (db.name) {
              try {
                idb.deleteDatabase(db.name);
              } catch {
                /* 单库删除失败不影响其余 */
              }
            }
          }
        })
        .catch(() => {
          /* 枚举失败忽略 */
        });
    }
  } catch {
    /* indexedDB 不可用忽略 */
  }
}
